// localStorage with a "cb." prefix. `?as=<label>` in the URL namespaces every key, so two
// tabs can be two different players while testing.
const label = new URLSearchParams(location.search).get('as')?.replace(/[^a-z0-9]/gi, '').slice(0, 12);
const prefix = label ? `cb.${label}.` : 'cb.';

export function storageKey(key: string): string {
  return prefix + key;
}

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(storageKey(key));
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, value: unknown) {
  try {
    if (value === undefined || value === null) localStorage.removeItem(storageKey(key));
    else localStorage.setItem(storageKey(key), JSON.stringify(value));
  } catch {
    // Private mode or full storage: the app still works, it just forgets.
  }
}

/** Keys (without the prefix) that start with `start`. */
export function keysStartingWith(start: string): string[] {
  const out: string[] = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(prefix + start)) out.push(k.slice(prefix.length));
    }
  } catch {
    // no storage
  }
  return out;
}

/** Like `save`, but says whether it worked. */
export function trySave(key: string, value: unknown): boolean {
  try {
    localStorage.setItem(storageKey(key), JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
